import { Resolvers } from '@apollo/client/core';

import { gql } from 'apollo-angular';

export const StorefrontBasicFragment = gql`
  fragment StorefrontBasic on Storefront {
    storefrontId
    catalogId
    name
    partnerId
    currencyCode
  }
`;

export interface StorefrontBasic {
  storefrontId: string;
  catalogId: string;
  name: string;
  partnerId: number;
  currencyCode: string;
}

